export const updatContactHandler = (state, action) => ({
  ...state,
  contact: {
    ...state.contact,
    [action.field]: action.value,
  },
});

export const updateProvinceHandler = (state, action) => ({
  ...state,
  province: {
    ...state.province,
    ...action.data,
  },
});

export const updatePlanDetailsHandler = (state, action) => ({
  ...state,
  planDetails: {
    ...state.planDetails,
    ...action.data,
  },
});

export const updateLoaderHandler = (state, action) => ({
  ...state,
  loader: action.show,
});

export const updateAgreedToTermsHandler = (state, action) => ({
  ...state,
  agreedToTerms: {
    agreed: action.agreed,
    showToolTip: action.showToolTip,
  },
});

export const updateModalToShowHandler = (state, action) => ({
  ...state,
  modalToBeShown: {
    view: action.view,
    message: action.message,
    editPlan: action.editPlan,
  },
});

export const updateRecaptchaHandler = (state, action) => ({
  ...state,
  recaptcha: {
    ...state.recaptcha,
    ...action.data,
  },
});
